module.exports = __webpack_public_path__ + "img/screen.ce174b08.webp";